<template>
    <div>
        <DCard>
            <Form
                :nameserver-style="nameserverStyle"
                :dns-providers="dnsProviders"
                :errors="errors"
                @submit="eventCreate"
            />
        </DCard>
    </div>
</template>

<script>
import Form from '~@/Components/Products/DNSTemplate/Form'

export default {
    name: 'DNSTemplateCreate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        nameserverStyle: {
            type: Array,
            default () {
                return []
            }
        },
        dnsProviders: {
            type: Array,
            default () {
                return []
            }
        }
    },
    methods: {
        eventCreate (form) {
            form.post(this.$route('products.dns-templates.store'))
        }
    }
}
</script>
